// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"c31e7ac3","845":"4877472e"}[chunkId] + ".chunk.js";
};